import { render, staticRenderFns } from "./FRButton.vue?vue&type=template&id=4866c6f7&scoped=true&"
import script from "./FRButton.vue?vue&type=script&lang=js&"
export * from "./FRButton.vue?vue&type=script&lang=js&"
import style0 from "./FRButton.vue?vue&type=style&index=0&id=4866c6f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4866c6f7",
  null
  
)

export default component.exports